import { z } from 'zod/v4';
import {
  AI_FEEDBACK_ASSET_TYPE_VALUES,
  AI_FEEDBACK_PROCESS_TYPE_VALUES,
} from '../../constants.js';

export const AiFeedbackDataSchema = z.object({
  fileId: z.string().min(1, 'File ID is required'),
  assetId: z.string().min(1, 'Asset ID is required'),
  assetType: z.enum(AI_FEEDBACK_ASSET_TYPE_VALUES),
  aiProcessType: z.enum(AI_FEEDBACK_PROCESS_TYPE_VALUES),
  vote: z.union([z.literal(0), z.literal(1)]).optional(),
  text: z.string().optional(),
});

export const AiFeedbackResponseSchema = z.object({
  message: z.string(),
  feedbackId: z.string(),
});

export type IAiFeedbackData = z.infer<typeof AiFeedbackDataSchema>;
export type IAiFeedbackResponse = z.infer<typeof AiFeedbackResponseSchema>;
